import React from 'react';
import { AppProviders } from './app/providers';
import { AppRoutes } from './app/router/AppRoutes';

export default function App() {
  window.location.pathname !== '/' &&
    window.location.pathname !== '/login' &&
    window.location.pathname !== '/dashboard' &&
    localStorage.setItem('LAST_URL', window.location.pathname);

  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}
